import { cva } from "cva";
import { LandingPageBuildHtml } from "~/components/LandingPageV2/LandingPageBuildHtml";
import { FeatureListBlock as FeatureListBlockSchema } from "~/components/LandingPageV2/schemas";
import { FullWidthImage } from "~/ui-library/components/FullWidthImage";

export type FeatureListColumnGridBlockProps = {
  columns: 2 | 3 | 4;
  features: FeatureListBlockSchema["features"];
};

// eslint-disable-next-line tailwindcss/classnames-order
const listStyles = cva("grid grid-cols-1 gap-xl", {
  variants: {
    columns: {
      2: "lg:grid-cols-2 lg:gap-x-xl",
      3: "lg:grid-cols-3 lg:gap-x-l",
      4: "lg:grid-cols-4 md:grid-cols-2 lg:gap-x-m",
    },
  },
  defaultVariants: {
    columns: 2,
  },
});

export const FeatureListColumnGridBlock: React.FC<
  FeatureListColumnGridBlockProps
> = ({ columns, features }) => (
  <div className={listStyles({ columns })}>
    {features.map(({ description, image }, i) => (
      <div className="flex flex-col" key={`feature-list-col-grid-${i}`}>
        {image && (
          <FullWidthImage
            alt={image.alt}
            aspectRatio="4/3"
            className="mb-m"
            src={image.url}
          />
        )}
        <LandingPageBuildHtml html={description} />
      </div>
    ))}
  </div>
);
